import React from "react";
import { Icon, Label, Button, Segment, Popup, Dropdown, Flag, Grid } from "semantic-ui-react";
import SidebarTitle from "components/Sidebar/SidebarTitle";
import SecondaryButton from "components/Buttons/SecondaryButton";
import MainButton from "components/Buttons/MainButton";
import Autocomplete from "react-autocomplete";
import FilePreview from "../FilePreview";
import { noAccent } from "utils/accents";
import { DragDropTable } from "./DragDropTable";
import AddNurseHelpModal from "features/FolderManager/components/modals/AddNurseHelpModal";
import BlueButton from "components/Buttons/BlueButton";
import { b64toFile } from "utils/file";
import { EditAnalysesStyles as st } from "./styles";
import SidebarTvSec from "components/Sidebar/SidebarTvSec";
import { toast } from "react-toastify";

const LanguageOption = [
	{
		key: "synonymous",
		text: <Flag name="fr" />,
		value: "fr",
	},
	{
		key: "synonymous_en",
		text: <Flag name="gb" />,
		value: "en",
	},
	{
		key: "synonymous_de",
		text: <Flag name="de" />,
		value: "de",
	},
];

const getHighlightedText = (text, higlight) => {
	if (higlight.length >= 3) {
		//Split on higlight term and include term into parts, ignore case
		let parts = text.split(new RegExp(`(${higlight})`, "gi"));
		return (
			<span>
				{" "}
				{parts.map((part, i) => (
					<span key={i} style={part.toLowerCase() === higlight.toLowerCase() ? { backgroundColor: "yellow" } : {}}>
						{part}
					</span>
				))}{" "}
			</span>
		);
	} else return text;
};

//Wrapper used to prevent to many re-render of FilePreview iframe
const EditAnalyses = (props) => {
	let scans = props.prescription?.scans || [];
	return (
		<div style={st.outsideContainer}>
			{scans?.length > 0 &&
				!props.isMobile &&
				(!props.dualScreen?.presentationConnection?.id ||
					(props.dualScreen?.presentationConnection?.id && (props.dualScreen?.dashboardDisplay || props.dualScreen?.patientDisplay))) && (
					<FilePreview files={scans} telesec={props.folder.status === "HELP_NURSE"} disabled={false} />
				)}
			<EditAnalysesForm {...props} />
		</div>
	);
};

class EditAnalysesForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			analysesFactory: {
				add: [],
				remove: [],
				order: props.prescription?.analyses
					?.sort((a, b) => (a.order < b.order ? -1 : a.order > b.order ? 1 : 0))
					.map((ana) => ana.properties?.code ?? ana.code),
				motivations: props.prescription?.analyses
					.filter((a) => a.question_answers.some((qa) => qa.question && qa.question.motivation))
					.map((a) => {
						return { question_answer: a.question_answers.find((qa) => qa.question.motivation).id, value: a.motivation };
					}),
			},
			library: { ...props.library, list: props.library && props.library.list.map((ana) => ({ ...ana, persisted: false })) },
			packs:
				props.library && props.library.packs
					? props.library.packs.map((group) => ({
							...group,
							list: group.list.map((pack) => ({
								...pack,
								analyses: pack?.analyses?.map((ana) => ({
									...ana,
									persisted: this.props?.prescription?.analyses?.findIndex((anaPersisted) => anaPersisted.properties?.id === ana.id) !== -1,
								})),
							})),
					  }))
					: [],
			analyses: props.prescription?.analyses?.map((ana) => ({ ...ana, persisted: true })),
			autocompleteValue: "",
			helpNurseModal: false,
			enterPressed: false,
			language: "fr",
			motivations: [],
			sortedList: [],
		};
	}

	componentDidMount = () => {
		//focus on the analysis list after the load of the sidebar
		this.setState({
			sortedList: this.state.library && this.state.library.list.filter((anaLib) => anaLib.isSelectable).sort((a, b) => a.code.localeCompare(b.code)),
		});
		setTimeout(() => {
			if (this.props.showAllCatalog && this.props.prescription?.analyses?.length === 0 && this.input) this.input.focus();
		}, 500);
	};

	/** ANALYSES FUNCTIONS
	 *
	 * @returns {*}
	 */
	addAnalysisToSet = (analysis) => {
		if (
			this.state.analysesFactory.order.findIndex((i) => i === analysis.code) > -1 ||
			this.state.analysesFactory.remove.findIndex((i) => i.properties.id === analysis.id) > -1
		) {
			toast.warn(`L'analyse ${analysis.code} est déjà présente dans la liste`);
			return;
		}
		let analysesFactory = Object.assign({}, this.state.analysesFactory);

		if (analysis.persisted) {
			analysesFactory.remove = analysesFactory.remove.filter((elt) => elt.id !== analysis.id);
		} else {
			analysesFactory.add.push(analysis);
			analysesFactory.order.push(analysis.code);
		}
		this.setState({ analysesFactory: analysesFactory, autocompleteValue: "" });
	};

	addPack = (pack) => {
		let analysesFactory = Object.assign({}, this.state.analysesFactory);
		if (pack && pack.analysesPackages && pack.analysesPackages.length > 0)
			pack.analysesPackages
				.slice()
				.sort((a, b) => a.order - b.order)
				.forEach((ana) => {
					if (
						!ana.analysis.persisted &&
						analysesFactory.add.findIndex((i) => i.id === ana.analysis.id) === -1 &&
						ana.analysis.isSelectable &&
						analysesFactory.order.findIndex((i) => i === ana.analysis.code) === -1
					) {
						analysesFactory.add.push(ana.analysis);
						analysesFactory.order.push(ana.analysis.code);
					}
				});

		this.setState({ analysesFactory: analysesFactory });
	};

	saveMotivation = (questionAnswerId, value, analysisLibraryId) => {
		let analysesFactory = Object.assign({}, this.state.analysesFactory);
		if (questionAnswerId) {
			let index = analysesFactory.motivations.findIndex((m) => m.question_answer === questionAnswerId);
			if (index > -1) analysesFactory.motivations[index] = { question_answer: questionAnswerId, value: value, analysisLibraryId: analysisLibraryId };
			else analysesFactory.motivations.push({ question_answer: questionAnswerId, value: value, analysisLibraryId: analysisLibraryId });
		} else {
			let index = analysesFactory.motivations.findIndex((m) => m.analysisLibraryId === analysisLibraryId);
			if (index > -1) analysesFactory.motivations[index] = { question_answer: questionAnswerId, value: value, analysisLibraryId: analysisLibraryId };
			else analysesFactory.motivations.push({ question_answer: questionAnswerId, value: value, analysisLibraryId: analysisLibraryId });
		}
		this.setState({ analysesFactory: analysesFactory });
	};

	removeAnalysisFromSet = (analysis) => {
		let analysesFactory = Object.assign({}, this.state.analysesFactory);

		// Si non persisté, on le retire des éléments à ajouter
		if (!analysis.persisted) {
			analysesFactory.add = analysesFactory.add.filter((elt) => elt.id !== analysis.id);
			analysesFactory.order = analysesFactory.order.filter((elt) => elt !== analysis.code);
		} else {
			analysesFactory.remove.push(analysis);
		}

		this.setState({ analysesFactory: analysesFactory });
	};

	createPackList = (pack) => {
		if (pack)
			return (
				<div key={`pack-${pack.id}`}>
					<b>Analyses du pack :</b>
					{pack.analysesPackages.map((p) => (
						<div key={`packana-${p.analysis.id}`}>
							{p.analysis.code} - {p.analysis.label}
						</div>
					))}
				</div>
			);
	};

	createDataForAutocomplete = () => {
		return this.state.sortedList
			? this.state.sortedList.map((i) => ({
					key: i.catalog_code + i.catalog_id + i.code,
					label: (this.state.language === "de" ? i.label_de : this.state.language === "en" ? i.label_en : i.label) || i.label,
					code: i.code,
					sil: i.sil_code,
					value: i.code,
					synonyms:
						this.state.language === "de" && i.synonymous_de
							? i.synonymous_de.split(";")
							: this.state.language === "en" && i.synonymous_en
							? i.synonymous_en.split(";")
							: i.description
							? i.description.split(";")
							: [],
					added:
						this.state.analysesFactory.add.findIndex((elt) => elt.code === i.code) > -1 ||
						this.state.analyses?.findIndex((elt) => elt.properties.code === i.code) > -1,
					data: i,
			  }))
			: [];
	};

	removeAllAnalyses = () => {
		let analysesFactory = Object.assign({}, this.state.analysesFactory);
		this.state.analyses.filter((a) => !analysesFactory.remove.includes(a)).forEach((a) => analysesFactory.remove.push(a));
		analysesFactory.add = [];
		analysesFactory.order = [];
		this.setState({ analysesFactory: analysesFactory });
	};

	closeHelpNurseModal = () => {
		this.props.cleanScans();
		this.setState({ helpNurseModal: false });
	};

	addScanOrdoToPrescription = async (scan) => {
		await this.props.postScanPrescription(
			b64toFile(scan.rectoBase64, scan.format, 512, "scans-ordo.jpg"),
			scan.versoBase64 ? b64toFile(scan.versoBase64, scan.format, 512, "scans-ordo_back.jpg") : null,
			scan.barcodes,
			this.props.prescription.id,
			this.props.prescription.folderId,
			1
		);
		this.props.useScanOrdo(scan.id, this.props.prescription.id);
	};

	deleteScanPrescription = (prescriptionScan) => {
		this.props.deleteScanPrescription(prescriptionScan, this.props.prescription.id, this.props.prescription.folderId);
	};

	render() {
		let {
			prescription,
			hideOnSubmit = true,
			showAllCatalog,
			center,
			generalParameters,
			role,
			isMobile,
			folder,
			isDeposit,
			isDomicile,
			checkAnalysis,
		} = this.props;
		let { analysesFactory, analyses, library, autocompleteValue, helpNurseModal } = this.state;
		const hasTvSecComments = folder?.folderHelp?.comments?.filter((c) => c.manual).length > 0 || false;
		return (
			<div style={isMobile ? st.containerMobile : st.container}>
				<div style={st.containerColumn}>
					<div style={isMobile ? st.titleMobile : st.title}>
						<SidebarTitle
							title={
								<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
									<span>Modifier les analyses</span>
									{isDeposit && <Label color="orange">Ce dossier est un dépôt</Label>}
									{isDomicile && <Label color="orange">Ce dossier est un domicile</Label>}
								</div>
							}
							subtitle2={hasTvSecComments ? <SidebarTvSec comments={this.props.folder.folderHelp?.comments} /> : null}
						/>
					</div>
					<div style={st.containerAutocompleteOutside}>
						<div style={st.containerAutocomplete}>
							<div style={{ display: "flex" }}>
								<Autocomplete
									ref={(el) => (this.input = el)}
									getOptionLabel={(option) => option.title}
									items={this.createDataForAutocomplete()}
									shouldItemRender={(item, value) => {
										// recherche dans les synonymes
										if (value) {
											return (
												item.synonyms.findIndex((t) => noAccent(t.toLowerCase()).indexOf(noAccent(value.toLowerCase())) > -1) > -1 ||
												noAccent(item.code.toLowerCase()).indexOf(noAccent(value.toLowerCase())) > -1 ||
												(item.sil ? noAccent(item.sil.toLowerCase()).indexOf(noAccent(value.toLowerCase())) > -1 : false) ||
												noAccent(item.label.toLowerCase()).indexOf(noAccent(value.toLowerCase())) > -1
											);
										} else return true;
									}}
									sortItems={(itemA, itemB, value) => {
										if (itemA.value === value.toUpperCase()) return -1;
										if (value && itemA.value.startsWith(value.toUpperCase()) && !itemB.value.startsWith(value.toUpperCase())) return -1;
										if (itemA.value < itemB.value) return -1;
										if (itemA.value > itemB.value) return 1;
										return 0;
									}}
									getItemValue={(item) => item.value}
									wrapperProps={{ style: { width: "100%" } }}
									renderItem={(item, highlighted) => (
										<div
											key={item.key}
											style={{
												...st.autocompleteRenderItem,
												backgroundColor: item.added ? "#b5ecea" : highlighted ? "#eee" : "white",
												cursor: item.added ? "not-allowed" : "select",
											}}
										>
											<div style={st.autocompleteRenderDiv}>
												<span style={st.autocompleteRenderSpanCode}> {getHighlightedText(item.code, this.state.autocompleteValue)}</span>
												<span>{getHighlightedText(item.label, this.state.autocompleteValue)}</span>
											</div>
											<span style={st.autocompleteRenderSpanSynonyms}>
												{getHighlightedText(item.synonyms.join(", "), this.state.autocompleteValue)}
											</span>
										</div>
									)}
									menuStyle={st.autocompleteMenuStyle}
									renderInput={(props) => (
										<div style={st.searchInput.inputWrapper}>
											{autocompleteValue === "" && <Icon name="search" size="large" style={st.searchInput.icon} />}
											{autocompleteValue !== "" && (
												<Icon
													name="close"
													style={{ ...st.searchInput.icon, ...st.searchInput.closeIcon }}
													onClick={(e) => {
														if (e !== undefined) e.preventDefault();
														this.setState({ autocompleteValue: "" });
													}}
												/>
											)}
											<input
												type="text"
												{...props}
												id="autocomplete-input"
												style={st.searchInput.input}
												onKeyUp={(event) => {
													if (event.key === "Enter") {
														if (this.state.enterPressed === 2) {
															this.setState({ enterPressed: 0 });
															if (hideOnSubmit) this.props.hideSidebar();
															this.props.onSubmit(analysesFactory, prescription, prescription.folderId);
														} else this.setState({ enterPressed: this.state.enterPressed + 1 });
													} else this.setState({ enterPressed: 0 });
												}}
												placeholder={isMobile ? "Rechercher une analyse" : "Rechercher une analyse par libellé ou par code"}
											/>
										</div>
									)}
									value={autocompleteValue}
									onChange={(e) => this.setState({ autocompleteValue: e.target.value })}
									onSelect={(value, item) => {
										this.addAnalysisToSet(item.data);
									}}
								/>

								<Dropdown
									defaultValue="fr"
									style={st.searchInput.dropdownLang}
									fluid
									selection
									options={LanguageOption}
									onChange={(e, option) => this.setState({ language: option.value })}
								/>
							</div>
						</div>
					</div>
					<Grid style={{ margin: isMobile ? "-1rem -0.5rem" : "-1rem" }}>
						<Grid.Column computer={12} mobile={16}>
							<DragDropTable
								analyses={analyses}
								analysesFactory={analysesFactory}
								removeAnalysisFromSet={this.removeAnalysisFromSet}
								removeAllAnalyses={this.removeAllAnalyses}
								addAnalysisToSet={this.addAnalysisToSet}
								isSecretary={role !== "NURSE"}
								lang={this.state.language}
								isMobile={isMobile}
								saveMotivation={this.saveMotivation}
								hasTvSecComments={hasTvSecComments}
								checkAnalysis={(analysisId, checked) => checkAnalysis(folder.id, prescription.id, analysisId, checked)}
							/>
						</Grid.Column>
						<Grid.Column computer={4} mobile={16}>
							<Segment style={{ margin: "0.2em 0" }}>
								<Label color="teal" style={{ cursor: "context-menu" }} ribbon>
									Sélection rapide
								</Label>
								<div style={{ marginTop: "15px" }}>
									{analyses &&
										library &&
										library.list
											.filter((a) => a.isAvailableWithoutCatalog)
											.filter((a) => !analyses.concat(analysesFactory.add).some((af) => a.code === af.properties?.code))
											.map((a) => (
												<Popup
													position="top right"
													key={`popup-${a.id}`}
													content={a.label}
													trigger={
														<Button style={st.analysis} onClick={() => this.addAnalysisToSet(a)} circular>
															{a.code}
														</Button>
													}
												/>
											))}
								</div>
							</Segment>
							{showAllCatalog &&
								this.state.packs.filter(
									(group) =>
										group.list &&
										group.list.filter(
											(g) =>
												g.analysesPackages.length > 0 &&
												g.doctor &&
												prescription &&
												prescription.prescriber &&
												g.doctor === prescription.prescriber.code
										).length > 0
								).length > 0 && (
									<Segment style={{ margin: "0.2em 0" }}>
										<Label color="teal" style={{ cursor: "context-menu" }} ribbon>
											Packs prescripteur
										</Label>
										<div style={{ marginTop: "15px" }}>
											{this.state.packs
												.sort((a, b) => a.group.localeCompare(b.group))
												.map((group, packIndex) => {
													return group.list
														.filter(
															(g) =>
																g.analysesPackages.length > 0 &&
																g.doctor &&
																prescription &&
																prescription.prescriber &&
																g.doctor === prescription.prescriber.code
														)
														.map((p) => (
															<Popup
																position="top right"
																key={`popupgroup-${p.id}`}
																content={this.createPackList(p)}
																trigger={
																	<Button style={st.analysis} onClick={() => this.addPack(p)} circular>
																		{p.name !== "" ? p.name : p.label}
																	</Button>
																}
															/>
														));
												})}
										</div>
									</Segment>
								)}
							{showAllCatalog &&
								this.state.packs.filter((group) => group.list.filter((g) => g.analysesPackages.length > 0 && !g.doctor).length > 0).length > 0 && (
									<Segment style={{ margin: "0.2em 0" }}>
										<Label color="teal" style={{ cursor: "context-menu" }} ribbon>
											Packs
										</Label>
										<div style={{ marginTop: "15px" }}>
											{this.state.packs
												.sort((a, b) => a.group.localeCompare(b.group))
												.map((group, packIndex) => {
													return group.list
														.filter((g) => g.analysesPackages.length > 0 && !g.doctor)
														.map((p) => (
															<Popup
																position="top right"
																key={`popupgroup-${p.id}`}
																content={this.createPackList(p)}
																trigger={
																	<Button style={st.analysis} onClick={() => this.addPack(p)} circular>
																		{p.name !== "" ? p.name : p.label}
																	</Button>
																}
															/>
														));
												})}
										</div>
									</Segment>
								)}
						</Grid.Column>
					</Grid>

					<div style={st.containerButtons}>
						<SecondaryButton
							type="button"
							style={st.cancelButton}
							text="Annuler"
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								this.props.hideSidebar();
							}}
						/>
						{role === "NURSE" && generalParameters.helpNurse && center && center.isTvSecActivated && (
							<>
								<Popup
									content="Cette fonctionnalité permet aux infirmières de demander de l’aide aux secrétaires lors de la saisie d’un dossier."
									header="Faire appel à une secrétaire pour l'encodage des analyses"
									position="top left"
									basic
									trigger={
										<span>
											<BlueButton
												style={{
													width: "100%",
													alignSlef: "center",
												}}
												onClick={() => this.setState({ helpNurseModal: true })}
												text={
													<>
														<Icon name="bell" /> Télésecrétariat
													</>
												}
											/>
										</span>
									}
								/>
								<AddNurseHelpModal
									open={helpNurseModal}
									close={this.closeHelpNurseModal}
									createFolderHelp={(...args) => {
										this.props.createFolderHelp(...args);
										this.props.hideSidebar();
									}}
									folder={this.props.folder}
									scans={this.props.scans}
									addScanOrdoToPrescription={this.addScanOrdoToPrescription}
									removeScanOrdoFromList={this.removeScanOrdoFromList}
									docs={prescription?.scans}
									loadingScans={this.props.loadingScans}
									deleteScanPrescription={this.deleteScanPrescription}
									center={this.props.center}
									secretaries={this.props.secretaries}
									tvsec={true}
									deposit={false}
									documentTypeOptions={this.props.documentTypes?.list}
									getAllDocumentTypes={this.props.getAllDocumentTypes}
								/>
							</>
						)}
						<MainButton
							style={st.validateButton}
							text="Valider"
							type="button"
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								if (hideOnSubmit) this.props.hideSidebar();
								this.props.onSubmit(analysesFactory, prescription, prescription.folderId);
							}}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default EditAnalyses;
